import React, { useId } from "react";

const InputForLiaison = ({
  label,
  isEditable,
  value,
  onChange,
  name,
  type,
  error,
  errorMsg,
}) => {
  const id = useId();
  return (
    <>
      {isEditable ? (
        <>
          <div className="input_for_liaison">
            <label className="lab" htmlFor={id}>
              {label}
            </label>
            <div className={type === "num" ? "settings_liason_input" : ""}>
              {type === "num" && <span className="contry_code">+91</span>}
              <input
                className={type !== "num" ? "input_lias" : "input_lias_num"}
                id={id}
                name={name}
                value={value}
                onChange={(e) => onChange(e)}
              />
            </div>
            {error && (
              <span className="add_liaison_input_error_msg">{errorMsg}</span>
            )}
          </div>
        </>
      ) : (
        <>
          <div className="input_for_liaison">
            <label className="lab" htmlFor={id}>
              {label}
            </label>
            <label className="not_editable_details">
              {type === "num" ? `+91 ${value}` : value}
            </label>
          </div>
        </>
      )}
    </>
  );
};

export default InputForLiaison;
